import React, { useEffect, useRef, useState } from "react";
import "./banner.css";
import Global from "../../global";
import Share from "../share/share";
import { Link } from "react-router-dom";
import { favourited, favourites } from "../javascript/function";
import { UserStore } from "../store/store";
import LazyDiv from "../lazy/lazydiv";
import VideoModal from "../modals/videoModal";
import useCheckBoxedVideo from "../../hooks/useCheckBoxedVideo";
import { useTranslation } from "react-i18next";

const MovieBanner = (props) => {
  const videoDetail = useRef(props.newData);
  const videoAccess = useCheckBoxedVideo(videoDetail.current);
  const [ban, setBan] = useState([]);
  const mounted = useRef(false);
  const currentUser = UserStore.useState((s) => s.user);
  const [trail, setTrail] = useState("");
  const [videoShow, setVideoShow] = useState(false);
  const { t } = useTranslation(["translation"]);

  let videoIndex = currentUser.WATCHHISTORY.findIndex(
    (obj) => obj.video_id === props.banData.mediaid
  );

  let position =
    videoIndex === -1 ? 0 : currentUser.WATCHHISTORY[videoIndex].position;
  let duration =
    videoIndex === -1 ? 0 : currentUser.WATCHHISTORY[videoIndex].duration;
  let percent =
    videoIndex === -1 || !parseInt(position) || !parseInt(duration)
      ? 0
      : (parseInt(position) / parseInt(duration)) * 100;
  const finalPercent = useRef(Global.RPB ? percent : 0);
  const onOpenVideoModal = () => {
    setVideoShow(true);
  };
  const onCloseVideoModal = () => {
    setVideoShow(false);
  };

  useEffect(() => {
    mounted.current = true;
    if (mounted.current) {
      setBan(props.banData);
      setTrail(props.banData.TrailerId);

      /*       async function checkAccess(asset) {
        await InPlayer.Asset.checkAccessForAsset(asset)
        .then((data )=> {  
           let result = {video_id:props.banData.mediaid,paymemt:data.data}
           VideoStore.update((s) => {
            s.video = result;
          });
           setCheckAccess(true);
           setLoaded(true);
           
        }).catch((error)=>{setLoaded(true);});
        setLoaded(true);
  }
 */
    }

    return () => {
      mounted.current = false;
    };
  }, [props.banData]);

  if (ban !== null) {
    return (
      <div
        className={
          Global.TYPE === "News"
            ? "banner-wrapper no-top-padding"
            : "banner-wrapper .no-news-padding"
        }
      >
        <LazyDiv
          className="banner-wrap justify-content-between align-items-center"
          orient={"landscape"}
          style={{
            backgroundImage: Global.SHADING
              ? `url()`
              : ban.image
              ? `url(
                ` +
                ban.image +
                ` 
               )`
              : `url()`,
          }}
        >
          <img
            src={
              `https://cdn.jwplayer.com/v2/media/` +
              ban.mediaid +
              `/poster.jpg?width=1920`
            }
            style={{ display: "none" }}
            alt=""
          />
          <div
            className={Global.SHADING ? "left-wrap" : "left-wrap left-shade"}
          >
            <span className={Global.TEXTSHADOW ? "rnd" : "rnd no-text-shadow"}>
              {ban.PgRating}
            </span>
            <h2 className={Global.TEXTSHADOW ? "" : "no-text-shadow"}>
              {ban.title}
            </h2>

            <div className="bottoming">
              <span
                className={Global.TEXTSHADOW ? "tag" : "tag no-text-shadow"}
              >
                <b className={Global.TEXTSHADOW ? "" : "no-text-shadow"}>
                  {ban.Genre}
                </b>
              </span>
              <span
                className={Global.TEXTSHADOW ? "tag" : "tag no-text-shadow"}
              >
                {ban.ReleaseOn}
              </span>
              <span
                className={Global.TEXTSHADOW ? "tag" : "tag no-text-shadow"}
              >
                <b className={Global.TEXTSHADOW ? "" : "no-text-shadow"}>HD</b>
              </span>
              <span
                className={Global.TEXTSHADOW ? "tag" : "tag no-text-shadow"}
              >
                <b className={Global.TEXTSHADOW ? "" : "no-text-shadow"}>
                  {ban.MPAARating}
                </b>
              </span>
              <span
                className={
                  Global.TEXTSHADOW
                    ? "tag broken_mins"
                    : "tag no-text-shadow broken_mins"
                }
              >
                {Global.RTL
                  ? parseInt(ban.duration / 60) +
                    " " +
                    t("label_Minutes") +
                    " " +
                    parseInt(ban.duration % 60) +
                    " " +
                    t("label_Seconds")
                  : parseInt(ban.duration / 60) +
                    " " +
                    t("label_Minutes") +
                    "," +
                    parseInt(ban.duration % 60) +
                    " " +
                    t("label_Seconds")}
              </span>
            </div>
            <p
              className={
                Global.TEXTSHADOW ? "starring" : "starring no-text-shadow"
              }
            >
              {" "}
              {t("label_Starring") + " : " + ban.Actor}
            </p>
            <p
              className={
                Global.TEXTSHADOW ? "starring" : "starring no-text-shadow"
              }
            >
              {t("label_Audio") + " : " + ban.AudioTracks}
            </p>
            <p className={Global.TEXTSHADOW ? "" : "no-text-shadow"}>
              {ban.ShortDescription}
            </p>

            {/* <a href="movie-details.html" className="btn btn-hover mr-2"><i className="ri-order-play-fill mr-2" aria-hidden="true" />Watch Trailer</a> */}
            {videoAccess === "Access" ? (
              <Link
                to={"/" + props.match.params.AppId + "/watch/" + ban.mediaid}
                className="btn btn-hover"
              >
                <i className="fa fa-play mr-2" aria-hidden="true" />
                {t("btn_Watch")}
                <div
                  className={
                    videoIndex === -1 || !Global.RPB
                      ? "cwwrapper transparent"
                      : "cwwrapper"
                  }
                >
                  <div
                    className="cwprogress whited"
                    style={{ width: parseInt(finalPercent.current) + "%" }}
                  ></div>
                </div>
              </Link>
            ) : videoAccess === "Login" ? (
              <Link
                to={
                  "/" +
                  props.match.params.AppId +
                  "/login?redirect=" +
                  ban.mediaid +
                  "&type=video&after=login"
                }
                className="btn btn-hover"
              >
                {t("btn_Log_Watch")}
              </Link>
            ) : videoAccess === "Login with Premium" ? (
              <Link
                to={
                  "/" +
                  props.match.params.AppId +
                  "/login?redirect=" +
                  ban.mediaid +
                  "&type=video&after=premium"
                }
                className="btn btn-hover"
              >
                {t("btn_Log_Sub_Watch")}
              </Link>
            ) : videoAccess === "Premium" ? (
              <Link
                to={
                  "/" +
                  props.match.params.AppId +
                  "/premium/" +
                  ban.AssetId +
                  "?redirect=" +
                  ban.mediaid +
                  "&type=video&after=premium"
                }
                className="btn btn-hover"
              >
                {t("btn_Log_Sub_Watch")}
              </Link>
            ) : (
              ""
            )}

            {Global.FAVOURITES ? (
              <Link
                to="#!"
                className="icon-bttn"
                onClick={(event) => {
                  favourites(event, ban, "video");
                }}
                title={t("user_Favourites")}
              >
                <i
                  className={
                    favourited(ban.mediaid, currentUser.FAVOURITES)
                      ? "ri-check-fill text-white"
                      : "ri-add-line text-white"
                  }
                />
              </Link>
            ) : (
              ""
            )}
            {Global.SOS ? (
              <Link to="#!" className="icon-bttn share" title={t("user_Share")}>
                <i className="ri-share-line text-white" />
                <Share type={"video"} details={ban} {...props}></Share>
              </Link>
            ) : (
              ""
            )}
            {trail ? (
              <Link
                to="#!"
                className="icon-bttn"
                title={t("btn_Watch_Trailer")}
                onClick={(event) => {
                  event.preventDefault();
                  onOpenVideoModal();
                }}
              >
                <i className="ri-play-circle-line text-white" />
              </Link>
            ) : (
              ""
            )}
            {Global.OFFLINE ? (
              <Link to="#!" className="icon-bttn" title="Offline Download">
                <i className="ri-download-line text-white" />
              </Link>
            ) : (
              ""
            )}
          </div>
          <LazyDiv
            className={Global.SHADING ? "right-wrap rightshade" : ""}
            style={{
              backgroundImage: !Global.SHADING
                ? `url()`
                : `url(https://cdn.jwplayer.com/v2/media/` +
                  ban.mediaid +
                  `/poster.jpg?width=1920)`,
            }}
          >
            {/*  <video id="myVideo" autoPlay="autoPlay" loop="loop" muted={true} >
             <source src="images/video1.mp4" type="video/mp4"></source>
         </video> */}
          </LazyDiv>
        </LazyDiv>

        <VideoModal
          open={videoShow}
          onCloseModal={onCloseVideoModal}
          onOpenModal={onOpenVideoModal}
          trailer={trail}
        ></VideoModal>
      </div>
    );
  } else {
    return <div style={{ minHeight: "250px" }}></div>;
  }
};

export default MovieBanner;
